import { ajaxCart } from './ajax-cart'

export const clearCart = (widget) => {
  $.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    success: function () {
      ajaxCart(widget)
    },
    dataType: 'json'
  })
}
